import { render, staticRenderFns } from "./ChartCountTotalProducts.vue?vue&type=template&id=6b17e677&"
import script from "./ChartCountTotalProducts.vue?vue&type=script&lang=js&"
export * from "./ChartCountTotalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports